import React from 'react';
import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
  fabContainer: {
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    zIndex: 1000,
  },
  fabWrapper: {
    position: 'relative',
    width: '44px',
    height: '44px',
  },
  fabShadow: {
    position: 'absolute',
    inset: '0',
    borderRadius: '9999px',
    pointerEvents: 'none',
    boxShadow: `
      0px 0px 1px 0px rgba(0, 0, 0, 0.06),
      0px 6.55px 6px -4.36px rgba(0, 0, 0, 0.07)
    `,
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: '0',
      borderRadius: '9999px',
      background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.48) 0%, rgba(0, 0, 0, 0.12) 100%)',
      filter: 'blur(1px)',
      opacity: 0.48,
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '6.55px',
      left: '4.36px',
      right: '-4.36px',
      bottom: '-6.55px',
      borderRadius: '9999px',
      background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.35) 0%, rgba(0, 0, 0, 0.15) 100%)',
      filter: 'blur(6px)',
      opacity: 0.35,
    },
  },
  fab: {
    position: 'relative',
    width: '44px',
    height: '44px',
    borderRadius: '9999px',
    backgroundColor: '#ffffff',
    border: '1px solid #f0f0f0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    zIndex: 2,
    '&:active': {
      backgroundColor: '#ebebeb',
    },
  },
  copilotIcon: {
    width: '24px',
    height: '24px',
  },
});

interface CopilotFABSimpleProps {
  onClick: () => void;
}

const CopilotFABSimple: React.FC<CopilotFABSimpleProps> = ({ onClick }) => {
  const styles = useStyles();

  return (
    <div className={styles.fabContainer}>
      <div className={styles.fabWrapper}>
        <div className={styles.fabShadow} />
        <button 
          className={styles.fab}
          onClick={onClick}
          aria-label="Open Copilot"
          type="button"
        >
          <img 
            src="/src/assets/office/ribbon/Copilot.svg" 
            alt="Copilot" 
            className={styles.copilotIcon}
          />
        </button>
      </div>
    </div>
  );
};

export default CopilotFABSimple;
